import React, { memo } from "react";
import styles from "./simulazionePerformanceCompare.module.scss";
import colorsStore from "shared/store/colorsStore";
import ChartCompare from "./ChartCompare";
import { useTranslation } from "react-i18next";

type SimulazionePerformanceCompareProps = {
  data: any;
  data2: any;
  title: string;
};

const SimulazionePerformanceCompareComponent: React.FC<
  SimulazionePerformanceCompareProps
> = ({ data, data2, title = "" }) => {
  const { t } = useTranslation();
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  if (!data) {
    return null;
  }
  return (
    <div>
      {title && <div className={styles.title}>{title}</div>}
      <div className={`${styles.grid} ${styles[`gridCharts`]}`}>
        <ChartCompare
          data={
            data.analisi_backtest.simulazione_performance_indicatori_portafoglio
              .rendimento
          }
          data2={
            data2.analisi_backtest
              .simulazione_performance_indicatori_portafoglio.rendimento
          }
          title={t("portfolio.rendimento")}
        />
        <div className={styles.rightCharts}>
          <ChartCompare
            data={
              data.analisi_backtest
                .simulazione_performance_indicatori_portafoglio.sharpe
            }
            data2={
              data2.analisi_backtest
                .simulazione_performance_indicatori_portafoglio.sharpe
            }
            title={t("portfolio.sharpe")}
          />
          <div style={{ marginTop: 16 }}>
            <ChartCompare
              data={
                data.analisi_backtest
                  .simulazione_performance_indicatori_portafoglio.volatilita
              }
              data2={
                data2.analisi_backtest
                  .simulazione_performance_indicatori_portafoglio.volatilita
              }
              title={t("portfolio.volatilitaAnn")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const SimulazionePerformanceCompare = memo(
  SimulazionePerformanceCompareComponent,
  (prevProps, nextProps) => {
    return JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data);
  },
);

export default SimulazionePerformanceCompare;
